export default __webpack_public_path__ + "static/media/jovian12.963e2278.jpg";